import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44c32c3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home flex flex-col" }
const _hoisted_2 = { class: "container m-auto flex flex-col px-16 pt-4" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "home__title font-bold text-center mt-4" }, " Interactive Experience ", -1))
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "home__title text-center mt-8" }, "Interactive Experience", -1))
const _hoisted_9 = {
  class: "flex",
  style: {"flex":"0.25 0 0"}
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Make a butterfly ")
const _hoisted_11 = {
  key: 0,
  class: "absolute inset-0 pointer-events-none"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link_button = _resolveComponent("router-link-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_butterfly_sequence = _resolveComponent("butterfly-sequence")!
  const _directive_tap = _resolveDirective("tap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.mode === 'mobile')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("img", {
              src: require('@/assets/images/home/carilion-childrens-logo.svg'),
              class: "mx-auto mt-auto",
              style: {"width":"210px"}
            }, null, 8, _hoisted_3),
            _hoisted_4,
            _createElementVNode("img", {
              src: require('@/assets/images/home/butterfly.svg'),
              class: "mt-auto"
            }, null, 8, _hoisted_5),
            _createElementVNode("img", {
              src: require('@/assets/images/home/social_text_sm.svg'),
              class: "mx-auto mt-auto"
            }, null, 8, _hoisted_6)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("img", {
              src: require('@/assets/images/home/social_text.svg'),
              class: "mx-auto mt-auto"
            }, null, 8, _hoisted_7),
            _hoisted_8
          ], 64))
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_router_link, {
        to: _ctx.nextRoute,
        custom: ""
      }, {
        default: _withCtx(({ navigate }) => [
          _withDirectives(_createVNode(_component_router_link_button, { class: "m-auto" }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 2
          }, 1536), [
            [_directive_tap, navigate]
          ])
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    (_ctx.mode === 'kiosk')
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(_component_butterfly_sequence)
        ]))
      : _createCommentVNode("", true)
  ]))
}